module.exports = __webpack_public_path__ + "img/flag-poland.5014b978.png";